export const IS_WAITING = 'IS_WAITING';
export const IS_OPEN_NOTIF = 'IS_OPEN_NOTIF';
export const IS_OPEN_IS = 'IS_OPEN_IS';
export const IS_OPEN_PROFILE = 'IS_OPEN_PROFILE';
export const MODULE_PAGE_TITLE = 'MODULE_PAGE_TITLE';
export const OPEN_MODAL = 'OPEN_MODAL';

export const isWaiting = (is_waiting) => ({
    type: IS_WAITING,
    is_waiting
})

export const openModal = (modalType,open) => ({
    type: OPEN_MODAL,
    modalType,
    open
})


export const openNotif = (open) => ({
    type: IS_OPEN_NOTIF,
    open
})

export const openProfile = (open) => ({
    type: IS_OPEN_PROFILE,
    open
})

export const setModuleTitle = (title) => ({
    type: MODULE_PAGE_TITLE,
    title
})

export const openIs = (open) => ({
    type: IS_OPEN_IS,
    open
})

/* eslint-disable */
export const getFirstMessage = (data) => {
    let firstMessage = '';
    let x = 0;
    
    Object.keys(data).map(i => {
        if(x===0){
            firstMessage = data[i];
        }
        x++;
    });
    return firstMessage; 
}


/** WEBPACK FOOTER **
 ** ./src/Action.js
 **/